import React from 'react';
import { Route, BrowserRouter, Routes, Navigate } from 'react-router-dom';
import Login from './public/Login/Login';
import ForgotPassword from './public/ForgotPassword/ForgotPassword';
import ResetPassword from './public/ResetPassword/ResetPassword';
import Register from './public/Register/Register';
import Settings from './private/Settings/Settings';
import Dashboard from './private/Dashboard/Dashboard';
import Orders from './private/Orders/Orders';
import Monitors from './private/Monitors/Monitors';
import Automations from './private/Automations/Automations';
import OrderTemplates from './private/OrderTemplates/OrderTemplates';
import NewOrderTemplate from './private/OrderTemplates/NewOrderTemplate';
import WithdrawTemplates from './private/WithdrawTemplates/WithdrawTemplates';
import Reports from './private/Reports/Reports';
import Symbols from './private/Symbols/Symbols';
import Wallet from './private/Wallet/Wallet';
import WebHooks from './private/WebHooks/WebHooks';
import Strategies from './private/Strategies/Strategies';
import NewOrder from './private/Futures/NewOrder';
import NewLaunch from './private/Automations/LaunchAutomation/NewLaunch';
import AIAgent from './private/AIAgent/AIAgent';
import Agent from './private/Agent/Agent';
import Comecando from './private/Comecando/Comecando';
import Funcionalidades from './private/Funcionalidades/Funcionalidades';
import Trade from './private/Trade/Trade';
import Swap from './private/Swap/Swap';
import Orca from './private/Orca/Orca';
import OrcaLiquidity from './private/Orca/OrcaLiquidity';
import OrcaPortfolio from './private/Orca/OrcaPortfolio';
import OrcaPositions from './private/Orca/OrcaPositions';
import OrcaSwap from './private/Orca/OrcaSwap';
import EasyTrade from './private/EasyTrade/EasyTrade';
import ProfitMonitor from './private/ProfitMonitor/ProfitMonitor';
import ProfitMonitorDetail from './private/ProfitMonitor/ProfitMonitorDetail';
import PredadorStatus from './private/PredadorStatus/PredadorStatus';
import Predadores from './private/Predadores/Predadores';
import CryptoRadar from './private/CryptoRadar/CryptoRadar';
import ProfitVault from './private/ProfitVault/ProfitVault';
import TreinoInicial from './private/TreinoInicial/TreinoInicial';
import LogsPage from './private/Logs/LogsPage';
import CustodyGate from './components/CustodyGate';
import Baskets from './private/Baskets/Baskets';
import Deposit from './private/Deposit/Deposit';

function Router() {

    function PrivateRoute({ children }) {
        const isAuth = localStorage.getItem("token") !== null;
        return isAuth ? <CustodyGate>{children}</CustodyGate> : <Navigate to="/" />;
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" exact element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/register" element={<Register />} />
                <Route path="/settings" element={
                    <PrivateRoute>
                        <Settings />
                    </PrivateRoute>
                } />
                <Route path="/orders/:symbol?" element={
                    <PrivateRoute>
                        <Orders />
                    </PrivateRoute>
                } />
                <Route path="/forders/:symbol?" element={
                    <PrivateRoute>
                        <Orders />
                    </PrivateRoute>
                } />
                <Route path='/dashboard' element={
                    <PrivateRoute>
                        <Dashboard />
                    </PrivateRoute>
                } />
                <Route path='/monitors' element={
                    <PrivateRoute>
                        <Monitors />
                    </PrivateRoute>
                } />
                <Route path='/automations/launch/:id?' element={
                    <PrivateRoute>
                        <NewLaunch />
                    </PrivateRoute>
                } />
                <Route path='/automations' element={
                    <PrivateRoute>
                        <Automations />
                    </PrivateRoute>
                } />
                <Route path='/reports' element={
                    <PrivateRoute>
                        <Reports />
                    </PrivateRoute>
                } />
                <Route path='/freports' element={
                    <PrivateRoute>
                        <Reports />
                    </PrivateRoute>
                } />
                <Route path='/symbols' element={
                    <PrivateRoute>
                        <Symbols />
                    </PrivateRoute>
                } />
                <Route path='/orderTemplates/:symbol?' element={
                    <PrivateRoute>
                        <OrderTemplates />
                    </PrivateRoute>
                } />
                <Route path='/fOrderTemplates/:symbol?' element={
                    <PrivateRoute>
                        <OrderTemplates />
                    </PrivateRoute>
                } />
                <Route path='/orderTemplate/:orderTemplateId?' element={
                    <PrivateRoute>
                        <NewOrderTemplate />
                    </PrivateRoute>
                } />
                <Route path='/withdrawTemplates/:coin?' element={
                    <PrivateRoute>
                        <WithdrawTemplates />
                    </PrivateRoute>
                } />
                <Route path='/wallet' element={
                    <PrivateRoute>
                        <Wallet />
                    </PrivateRoute>
                } />
                <Route path='/deposito' element={
                    <PrivateRoute>
                        <Deposit />
                    </PrivateRoute>
                } />
                <Route path='/cestas' element={
                    <PrivateRoute>
                        <Baskets />
                    </PrivateRoute>
                } />
                <Route path='/webhooks' element={
                    <PrivateRoute>
                        <WebHooks />
                    </PrivateRoute>
                } />
                <Route path='/strategies' element={
                    <PrivateRoute>
                        <Strategies />
                    </PrivateRoute>
                } />
                <Route path='/futures' element={
                    <PrivateRoute>
                        <NewOrder />
                    </PrivateRoute>
                } />
                <Route path='/ai-agent' element={
                    <PrivateRoute>
                        <AIAgent />
                    </PrivateRoute>
                } />
                <Route path='/agent' element={
                    <PrivateRoute>
                        <Agent />
                    </PrivateRoute>
                } />
                <Route path='/comecando' element={
                    <PrivateRoute>
                        <Comecando />
                    </PrivateRoute>
                } />
                <Route path='/funcionalidades' element={
                    <PrivateRoute>
                        <Funcionalidades />
                    </PrivateRoute>
                } />
                <Route path='/trade' element={
                    <PrivateRoute>
                        <Trade />
                    </PrivateRoute>
                } />
                <Route path='/swap' element={
                    <PrivateRoute>
                        <Swap />
                    </PrivateRoute>
                } />
                <Route path='/orca' element={
                    <PrivateRoute>
                        <Orca />
                    </PrivateRoute>
                } />
                <Route path='/orca/liquidity/:poolAddress' element={
                    <PrivateRoute>
                        <OrcaLiquidity />
                    </PrivateRoute>
                } />
                <Route path='/orca/swap' element={
                    <PrivateRoute>
                        <OrcaSwap />
                    </PrivateRoute>
                } />
                <Route path='/orca/portfolio' element={
                    <PrivateRoute>
                        <OrcaPortfolio />
                    </PrivateRoute>
                } />
                <Route path='/orca/positions' element={
                    <PrivateRoute>
                        <OrcaPositions />
                    </PrivateRoute>
                } />
                <Route path='/easytrade' element={
                    <PrivateRoute>
                        <EasyTrade />
                    </PrivateRoute>
                } />
                <Route path='/crypto-radar' element={
                    <PrivateRoute>
                        <CryptoRadar />
                    </PrivateRoute>
                } />
                <Route path='/profit-monitor/:symbol' element={
                    <PrivateRoute>
                        <ProfitMonitorDetail />
                    </PrivateRoute>
                } />
                <Route path='/profit-monitor' element={
                    <PrivateRoute>
                        <ProfitMonitor />
                    </PrivateRoute>
                } />
                <Route path='/predadores' element={
                    <PrivateRoute>
                        <Predadores />
                    </PrivateRoute>
                } />
                <Route path='/predadores/:mode' element={
                    <PrivateRoute>
                        <Predadores />
                    </PrivateRoute>
                } />
                <Route path='/predador-status' element={
                    <PrivateRoute>
                        <PredadorStatus />
                    </PrivateRoute>
                } />
                <Route path='/pnl' element={
                    <PrivateRoute>
                        <ProfitVault />
                    </PrivateRoute>
                } />
                <Route path='/caixa-acumulado' element={<Navigate to="/pnl" replace />} />
                <Route path='/logs' element={
                    <PrivateRoute>
                        <LogsPage />
                    </PrivateRoute>
                } />
                <Route path='/treino-inicial' element={
                    <PrivateRoute>
                        <TreinoInicial />
                    </PrivateRoute>
                } />
            </Routes>
        </BrowserRouter>
    )
}

export default Router;